import { Stack, TextField } from "@mui/material";
import TimePicker24Field from "./TimePicker24Field";

function pad(value) {
  return String(value).padStart(2, "0");
}

function splitDateTimeLocal(value) {
  const [date = "", time = ""] = String(value || "").split("T");
  return { date, time: time.slice(0, 5) };
}

function parseTimePickerValue(value) {
  if (!value || typeof value !== "string") return null;
  const [hours, minutes] = value.split(":").map(Number);
  if (!Number.isInteger(hours) || !Number.isInteger(minutes)) return null;
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
}

function formatTimePickerValue(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function combineDateTimeLocal(date, time) {
  if (!date) return "";
  return `${date}T${time || "00:00"}`;
}

export default function DateTimeLocal24Field({
  label,
  value,
  onChange,
  size,
  disabled,
  required,
  fullWidth = true,
}) {
  const { date, time } = splitDateTimeLocal(value);

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ width: fullWidth ? "100%" : "auto" }}>
      <TextField
        fullWidth={fullWidth}
        size={size}
        label={label}
        type="date"
        value={date}
        onChange={(event) => onChange(combineDateTimeLocal(event.target.value, time))}
        disabled={disabled}
        required={required}
        InputLabelProps={{ shrink: true }}
      />
      <TimePicker24Field
        label="Ora"
        value={parseTimePickerValue(time)}
        onChange={(nextValue) => onChange(combineDateTimeLocal(date, formatTimePickerValue(nextValue)))}
        ampm={false}
        format="HH:mm"
        disabled={disabled || !date}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth={fullWidth}
            size={size}
            placeholder="09:00"
            inputProps={{
              ...params.inputProps,
              readOnly: true,
              autoComplete: "off",
              "aria-autocomplete": "none",
            }}
            InputProps={{
              ...params.InputProps,
              autoComplete: "off",
            }}
          />
        )}
      />
    </Stack>
  );
}
